import { Component, OnInit, OnDestroy, Input, ViewChild, Inject, Optional } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
} from "@angular/forms";
import {
  getValidationStatus,
  handleValidationErrorMessage,
  isFormValid,
  validateFormControlsByName,
  getErrorMessage,
  getFullName,
  validateAtLeastOneInput,
  onHoursInput,
  onHoursInputWithExcluding,
  getMinutes,
  getTime,
} from "../../../../utilities/utils";
import { TableService } from "../../../shared/table/table.service";
import { EmployessService } from "../../../../shared/employess/employess.service";
import { DictionariesService } from "../../../../shared/dictionaries/dictionaries.service";
import {
  invalidDate,
  invalidHrs,
  invalidHrsMore,
} from "../../../../utilities/validators";
import { AnnualLeavingService } from "../../../../shared/employess/annual-leaving/annual-leaving.service";
import { NbToastrService, NbDialogService, NB_WINDOW_CONTEXT } from "@nebular/theme";
import { AuthUserService } from "../../../../@core/data/auth-user.service";
import { Subject, Subscription, debounceTime, finalize } from "rxjs";
import { QuestionDialogComponent } from "../../../shared/question-dialog/question-dialog.component";
import * as moment from "moment";
import { eventsErrors } from "../../events-errors";
import { OverviewService } from "../../../../shared/employess/overview/overview.service";
import { LoadingStatus } from "../../../shared/loading-status.enum";
import {
  EmployeeScheduleCalendar,
  EmployeeScheduleSummary,
} from "../../overview/overview-calendar/overview-calendar.component";
import { ConfirmRequestHoursComponent } from "../confirm-request-hours/confirm-request-hours.component";
import { ExplainAnnualLeaveComponent } from "../explain-annual-leave/explain-annual-leave.component";
import { ExplanationAnnualLeave } from "../model/explanation-annual-leave.model";
import { CurrentCareHomeService } from "../../../../@core/data/current-care-home.service";
import { PeriodCheckDialogComponent } from "../period-check-dialog/period-check-dialog.component";
import {
  isSicknessEventName,
  openUnifiedSicknessForm,
} from "../../events/unified-event-form";

enum ContractStatus {
  CANCELLED = "canceled",
  ACTIVE = "runing",
}
@Component({
  selector: "ngx-new-annual-leaving",
  templateUrl: "./new-annual-leaving.component.html",
  styleUrls: ["./new-annual-leaving.component.scss"],
})
export class NewAnnualLeavingComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  public errorMessages = eventsErrors;
  public employees: any = [];
  public eventTypes: any = [];
  public employeeContracts: any = [];
  public explanationAnnualLeave: ExplanationAnnualLeave = null;
  public form: UntypedFormGroup;
  public controlNames = [
    "employeeId",
    "eventType",
    "leavingStart",
    "leavingEnd",
  ];
  public contractControlNames = [];
  public utils = {
    getValidationStatus,
    handleValidationErrorMessage,
    isFormValid,
    validateFormControlsByName,
    getFullName,
    validateAtLeastOneInput,
    onHoursInput,
    onHoursInputWithExcluding,
  };
  public showAnnualLeavingTable = false;
  public showASInfo: boolean = false;
  public givenHrsSum = "00:00";
  public givenHrsSumMinutes = 0;
  public recommendedHrsSum = "00:00";
  public recommendedHrsSumMinutes = 0;
  public maxHrsCanGive = "00:00";
  public maxHrsCanGiveMinutes = 0;
  public isGivenMoreThanRecommended = false;
  public isGivenMoreThanMax = false;
  public buttonDetailsText = "Hide full year AL";
  public showDetails = true;
  public upToDateText = "";
  public careHomeId = this.authUserService.getCareHomeId();
  public careHome: any;
  private employeeId = 0;
  private employeeUid = "";
  public canSave = true;

  schedule: EmployeeScheduleCalendar[] = [];
  scheduleSummary: EmployeeScheduleSummary[] = [];

  public calendarData = {
    startDate: moment(),
    endDate: moment(),
    months: [],
  };
  public dateRange = {
    from: moment().subtract(3, "days"),
    to: moment().add(3, "days"),
  };
  public calendarMessageLeave = "";
  public calendarMessageShifts = "";
  public leaveDays = 0;
  public LoadingStatus: typeof LoadingStatus = LoadingStatus;
  public dataLoaded: LoadingStatus = LoadingStatus.NOT_LOADED;
  public tableIdentifier?: string;

  private previousReqRange: IPreviousReq = { from: undefined, to: undefined };
  private previousReqRangeContracts: IPreviousReq = {
    from: undefined,
    to: undefined,
  };

  public hasNoActiveContract: boolean = true;
  public noActiveContractMsg: string =
    "This employee has no active contract, it is not possible to add AL, please contact the HR department";
  employeeName: any;
  employeeFullName: string;

  contractsLoading = false;

  @ViewChild("leaveItem") leaveItem;

  alText = "";
  events = [];
  employeeStatus: string = "";

  parentalLeaveId: number = null;
  materialityLeaveId: number = null;
  LeaveId: number = null;
  annualLeaveId: number = null;
  requestOffId: number = null;
  /** e360 Add Event — Type of Event can switch to sickness window */
  private unifiedEvent = false;

  private contractsSubject = new Subject();
  constructor(
    private tableService: TableService,
    private authUserService: AuthUserService,
    private employeeService: EmployessService,
    private dictionariesService: DictionariesService,
    private annualLeavingService: AnnualLeavingService,
    private toastrService: NbToastrService,
    private formBuilder: UntypedFormBuilder,
    private dialogService: NbDialogService,
    private overviewService: OverviewService,
    private careHomeService: CurrentCareHomeService,
    @Optional() @Inject(NB_WINDOW_CONTEXT) private windowContext: any,
  ) {
    const params = this.resolveParams();
    this.employeeId = params.employeeId || 0;
    this.employeeUid = params.employeeUid || "";
    this.careHomeId = params.careHomeId || this.authUserService.getCareHomeId();
    this.alText = params.alText || "";
    this.employeeStatus = params.employeeStatus || "";
    this.tableIdentifier = params.tableIdentifier;
    this.unifiedEvent = !!params.unifiedEvent;
  }

  private resolveParams(): any {
    const fromTable = this.tableService.getValue();
    if (fromTable && fromTable.unifiedEvent !== undefined) {
      return fromTable;
    }
    // OverlayShell child injector passes params directly as NB_WINDOW_CONTEXT
    if (this.windowContext && this.windowContext.unifiedEvent !== undefined) {
      return this.windowContext;
    }
    // Fallback if parent injector still has OverlayShellContext wrapper
    if (this.windowContext && this.windowContext.componentContext) {
      return this.windowContext.componentContext;
    }
    return fromTable || this.windowContext || {};
  }

  ngOnInit() {
    this.givenHrsSum = "00:00";
    this.givenHrsSumMinutes = 0;
    this.createForm();

    // Must subscribe before patchValues — otherwise prefills emit into a Subject with no listeners.
    this.subscription.add(
      this.contractsSubject.pipe(debounceTime(300)).subscribe(() => {
        this.searchforContracts();
      }),
    );

    this.subscription.add(
      this.dictionariesService.getEventTypes().subscribe((response: any) => {
        const allTypes = response.result.wordsFromDictionary || [];
        const params = this.resolveParams();
        // Re-resolve here — constructor can race with overlay injector / setValue.
        this.unifiedEvent = !!params.unifiedEvent;

        // Final list once — never reassign after patchValue (breaks Given Hrs).
        this.eventTypes = this.unifiedEvent
          ? allTypes.slice()
          : allTypes.filter(
              (word) => !word.wordFullName.includes("Sickness"),
            );

        this.parentalLeaveId =
          allTypes.find((i) => i.wordShortName == "PL")?.id || null;

        this.materialityLeaveId =
          allTypes.find((i) => i.wordShortName == "ML")?.id || null;

        this.requestOffId =
          allTypes.find((i) => i.wordShortName == "RO")?.id || null;

        this.annualLeaveId =
          allTypes.find((word) => word.wordFullName === "Annual leave")?.id ||
          null;

        const selectedId = params.eventTypeId || this.annualLeaveId;
        this.form.get("eventType").patchValue(selectedId);
      }),
    );
    this.subscription.add(
      this.employeeService
        .getEmployeesByCareHome(this.careHomeId)
        .subscribe((response: any) => {
          response.result.employeesLines.map(
            (i) =>
              (i.fullName = getFullName(
                i.employeeFirstName,
                i.employeeSurname,
              )),
          );

          const employee = response.result.employeesLines.find(
            (i) => i.employeeId === this.employeeId,
          );

          if (employee) this.employeeFullName = employee.fullName;

          return (this.employees = response.result.employeesLines);
        }),
    );
    if (this.tableService.getValue()) {
      this.patchValues();
      this.careHomeId = this.tableService.getValue().careHomeId;
    }
  }

  createForm() {
    this.form = new UntypedFormGroup({
      employeeId: new UntypedFormControl(null, [Validators.required]),
      employeeUid: new UntypedFormControl(null, [Validators.required]),
      eventType: new UntypedFormControl(null, [Validators.required]),
      leavingStart: new UntypedFormControl(null, [
        Validators.required,
        invalidDate,
      ]),
      leavingEnd: new UntypedFormControl(null, [
        Validators.required,
        invalidDate,
      ]),
      firstDayAvailable: new UntypedFormControl(null),
      given: new UntypedFormControl(null),
      description: new UntypedFormControl(null, [Validators.required]),
      requiresAcceptance: new UntypedFormControl(false),
    });

    this.subscription.add(
      this.form.get("leavingEnd").valueChanges.subscribe((value: any) => {
        this.dateRange.to = moment(value).add(2, "days");
        this.form.patchValue({
          firstDayAvailable: moment(value).add(1, "d"),
        });
        if (this.form.get("leavingEnd").value) {
          if (this.checkIfPreviousIsSame(this.previousReqRangeContracts)) {
            return;
          }
          this.contractsSubject.next(true);
        }
      }),
    );

    this.subscription.add(
      this.form.get("leavingStart").valueChanges.subscribe((value: any) => {
        this.dateRange.from = moment(value).subtract(2, "days");
        this.upToDateText = moment(value).format("DD/MM/YYYY");
        if (this.form.get("leavingStart").value) {
          if (this.checkIfPreviousIsSame(this.previousReqRangeContracts)) {
            return;
          }
          this.contractsSubject.next(true);
        }
      }),
    );

    this.subscription.add(
      this.form.get("employeeId").valueChanges.subscribe((value: any) => {
        if (value) {
          const employeeUid = this.employees.find(
            (employee) => employee.employeeId === value,
          ).employeeUid;
          this.form.controls.employeeUid.setValue(employeeUid);
          this.contractsSubject.next(true);
        }
      }),
    );

    this.subscription.add(
      this.form
        .get("firstDayAvailable")
        .valueChanges.subscribe((value: any) => {
          if (
            moment(this.form.get("leavingEnd").value).isSameOrAfter(
              moment(value),
              "date",
            )
          ) {
            this.form
              .get("firstDayAvailable")
              .setErrors({ dateGreaterOrEqualThan: true });
          } else if (!this.isFDAEmptyOrNextAfterEnd()) {
            this.form
              .get("firstDayAvailable")
              .setErrors({ dateFDAEmptyOrNextAfterEnd: true });
          } else {
            this.form.get("firstDayAvailable").setErrors(null);
          }
        }),
    );

    this.subscription.add(
      this.form.get("eventType").valueChanges.subscribe((eventTypeId) => {
        if (this.unifiedEvent) {
          const eventType = this.eventTypes.find(
            (x) => Number(x.id) === Number(eventTypeId),
          );
          if (eventType && isSicknessEventName(eventType.wordFullName)) {
            openUnifiedSicknessForm(this.tableService, {
              employeeId: this.form.get("employeeId").value,
              employeeUid: this.form.get("employeeUid").value,
              sicknessStart: this.form.get("leavingStart").value,
              sicknessEnd: this.form.get("leavingEnd").value,
              firstDayAvailable: this.form.get("firstDayAvailable").value,
              description: this.form.get("description").value,
              eventTypeId,
              alText: this.alText,
              events: this.events,
              employeeStatus: this.employeeStatus,
              careHomeId: this.careHomeId,
              tableIdentifier: this.tableIdentifier,
              unifiedEvent: true,
            });
            return;
          }
        }
        if (this.form.get("leavingStart").value) {
          this.checkLast6Months();
        }
      }),
    );
  }

  checkIfPreviousIsSame(previous: IPreviousReq): boolean {
    return (
      moment(previous.from).isSame(moment(this.dateRange.from, "day")) &&
      moment(previous.to).isSame(moment(this.dateRange.to, "day"))
    );
  }

  onStartDateInput(event: any) {
    const date = event.value;
    const startDate = moment(date).subtract(2, "days");
    this.dateRange.from = startDate;
    if (this.form.get("leavingEnd").value === null) {
      this.form.get("leavingEnd").setValue(date);
      this.dateRange.to = moment(date).add(7, "days");
    } else {
      this.dateRange.to = moment(this.form.get("leavingEnd").value).add(
        2,
        "days",
      );
    }
    if (this.checkIfPreviousIsSame(this.previousReqRange)) {
      return;
    }

    this.getCalendarData();
  }

  onEndDateInput(event: any) {
    this.form.get("leavingEnd").setValue(event.value);
    this.dateRange.to = moment(event.value).add(2, "days");
    if (this.form.get("leavingStart").value) {
      if (this.checkIfPreviousIsSame(this.previousReqRange)) {
        return;
      }
    }
    this.getCalendarData();
  }

  clearFirstDayAvailable() {
    this.form.patchValue({ firstDayAvailable: null });
  }

  patchValues() {
    const values = this.resolveParams();
    this.form.get("employeeId").patchValue(values.employeeId);
    this.form.get("employeeUid").patchValue(values.employeeUid);
    if (values.leavingStart) {
      this.form
        .get("leavingStart")
        .patchValue(this.parseEventDate(values.leavingStart));
    }
    if (values.leavingEnd) {
      this.form
        .get("leavingEnd")
        .patchValue(this.parseEventDate(values.leavingEnd));
    }
    if (values.firstDayAvailable) {
      this.form
        .get("firstDayAvailable")
        .patchValue(this.parseEventDate(values.firstDayAvailable));
    }
    if (values.description) {
      this.form.get("description").patchValue(values.description);
    }
    if (values.eventType === "Annual leave") {
      // 103 seems to be the eventType code for 'Annual leave'
      this.form.get("eventType").patchValue(103);
    }

    // Programmatic date patch does not go through (dateChange) handlers —
    // force the same refresh as manual date pick (contracts + calendar).
    this.refreshAfterPrefillDates();
  }

  private refreshAfterPrefillDates() {
    const start = this.form.get("leavingStart").value;
    const end = this.form.get("leavingEnd").value;
    if (!start || !end || !this.form.get("employeeId").value) {
      return;
    }
    this.dateRange.from = moment(start).subtract(2, "days");
    this.dateRange.to = moment(end).add(2, "days");
    this.upToDateText = moment(start).format("DD/MM/YYYY");
    this.previousReqRangeContracts = { from: undefined, to: undefined };
    this.previousReqRange = { from: undefined, to: undefined };
    // Call directly — do not rely on Subject debounce after programmatic prefill.
    this.searchforContracts();
    this.getCalendarData();
  }

  private parseEventDate(value: any) {
    if (!value) {
      return value;
    }
    if (moment.isMoment(value) || value instanceof Date) {
      return moment(value);
    }
    const parsed = moment(
      value,
      ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY"],
      true,
    );
    return parsed.isValid() ? parsed : moment(value);
  }

  updateValues() {
    this.employeeContracts.forEach((leaving) =>
      this.form.patchValue({
        [`leaving-${leaving.contractId}`]: this.form.get(
          `leaving-${leaving.contractId}`,
        ).value,
      }),
    );

    Object.keys(this.form.controls).forEach((key) => {
      if (key.includes("leaving-")) {
        this.form.get(key).valueChanges.subscribe((value: any) => {
          this.handleCalculateGivenHrs();
        });
      }
    });
    this.handleCalculateGivenHrs();
  }

  searchforContracts() {
    this.contractsLoading = true;
    this.previousReqRangeContracts["from"] = this.dateRange.from;
    this.previousReqRangeContracts["to"] = this.dateRange.to;
    this.isGivenMoreThanRecommended = false;
    if (
      this.form.get("leavingStart").value == null ||
      this.form.get("leavingEnd").value == null ||
      this.form.get("employeeId").value == null
    ) {
      this.contractsLoading = false;
      return;
    }
    this.subscription.add(
      this.employeeService
        .getContractsByEmployeeUidAndDateForAL(
          this.form.get("employeeUid").value,
          this.form.get("leavingStart").value,
          this.form.get("leavingEnd").value,
          true,
        )
        .pipe(
          finalize(() => {
            this.contractsLoading = false;
          }),
        )
        .subscribe((response: any) => {
          this.employeeContracts = response.result.contractsLines;
          this.explanationAnnualLeave = response.result.alDetailedInfo;
          this.alText = response.result.alCalculationInfo;
          this.getSum("recommendedHrs");
          this.getSum("maxHrs");
          if (
            this.employeeContracts &&
            this.employeeContracts[0] &&
            this.employeeContracts[0].employeeStatus === "Inactive"
          ) {
            this.toastrService.danger(
              "Employee is inactive, you cannot add AL or sickness",
              "Error",
              { duration: 60000, destroyByClick: true },
            );
          } else {
            this.employeeContracts.forEach((leaving) => {
              this.form.addControl(
                `leaving-${leaving.contractId}`,
                this.formBuilder.control("0:00", [Validators.required]),
              );
              if (leaving.contracStatus == "canceled") {
                this.form.get(`leaving-${leaving.contractId}`).disable();
              }
            });
            this.showAnnualLeavingTable = true;
            this.form.get("firstDayAvailable").markAsTouched();
            this.form.get("description").markAsTouched();
            this.contractControlNames = [];
            Object.keys(this.form.controls).forEach((key) => {
              if (key.includes("leaving-")) {
                this.contractControlNames.push(key);
              }
            });
            this.updateValues();
            const start = this.form.get("leavingStart").value;
            const end = this.form.get("leavingEnd").value;
            this.employeeContracts.forEach((leaving) => {
              if (
                leaving.contracStatus === "waiting for start" ||
                leaving.contracStatus === "runing"
              ) {
                this.form.controls[
                  `leaving-${leaving.contractId}`
                ].clearValidators();
                // this.form.controls[`leaving-${leaving.contractId}`].setValidators([invalidHrsMore(leaving.contractHoursPerWeek, this.setHours(leaving), start, end), invalidHrs(leaving.contractHoursPerWeek, this.setHours(leaving), start, end)])
                this.form.controls[
                  `leaving-${leaving.contractId}`
                ].setValidators([
                  invalidHrs(
                    leaving.contractHoursPerWeek,
                    this.setHours(leaving),
                    start,
                    end,
                  ),
                ]);
                this.form
                  .get(`leaving-${leaving.contractId}`)
                  .setValue(this.setHours(leaving));
                this.form.controls[
                  `leaving-${leaving.contractId}`
                ].valueChanges.subscribe(() => {
                  this.form.updateValueAndValidity();
                });
                this.form.updateValueAndValidity();
              }
            });
          }
          if (this.employeeContracts && this.employeeContracts.length > 0) {
            for (const contract of this.employeeContracts)
              if (
                contract.contractRole !== "in Training" &&
                contract.contracStatus === "runing"
              ) {
                this.hasNoActiveContract = false;
              }
          }
        }),
    );
  }

  isAnyLeftHoursLessThanGiven() {
    let isAnyLeftHoursLessThanGiven = false;
    this.employeeContracts.forEach((leaving: any) => {
      const leftHours = this.parseHoursToFloat(
        leaving.leaveSettlements.leftHrs,
      );
      const given = this.form.get(`leaving-${leaving.contractId}`).value;
      if (leftHours < this.parseHoursToFloat(given))
        isAnyLeftHoursLessThanGiven = true;
    });
    return isAnyLeftHoursLessThanGiven;
  }

  parseHoursToFloat(hoursString: string): number {
    const [hours, minutes] = hoursString.split(":");
    const floatHours = parseInt(hours, 10) + parseInt(minutes, 10) / 60;
    return Math.round(floatHours * 100) / 100;
  }

  isFDAEmptyOrNextAfterEnd() {
    let isFDAEmptyOrNextAfterEnd = false;
    if (
      this.form.get("firstDayAvailable").value === null ||
      moment(this.form.get("leavingEnd").value)
        .add(1, "day")
        .isSame(this.form.get("firstDayAvailable").value)
    ) {
      isFDAEmptyOrNextAfterEnd = true;
    }
    return isFDAEmptyOrNextAfterEnd;
  }

  isHoursGivenInInactiveContractAndAnyAS() {
    let isHoursGivenInInactiveContract = false;
    this.employeeContracts.forEach((leaving: any) => {
      const given = this.form.get(`leaving-${leaving.contractId}`).value;
      if (leaving.contracStatus === ContractStatus.CANCELLED && given > 0) {
        isHoursGivenInInactiveContract = true;
      }
    });
    let showPopup = false;
    if (isHoursGivenInInactiveContract) {
      let isAnyAs = false;
      this.employeeContracts.forEach((leaving: any) => {
        const given = this.form.get(`leaving-${leaving.contractId}`).value;
        if (String(given).toLowerCase() === "as") {
          isAnyAs = true;
        }
      });
      showPopup = isAnyAs ? false : true;
    }
    return showPopup;
  }

  showNDAWarning() {
    this.dialogService.open(QuestionDialogComponent, {
      closeOnBackdropClick: false,
      context: {
        title: "Warning",
        message: `First day avaiable, must by set to next day after end day or empty for TBC.`,
        cancelLabel: "OK",
        hideOkButton: true,
      },
    });
  }

  showASWarning() {
    this.dialogService.open(QuestionDialogComponent, {
      closeOnBackdropClick: false,
      context: {
        title: "Warning",
        message: `You are assigning AL for an inactive contract. This AL will not appear on Rota or the Staff overview.<br>
                  Type AS into the relevant active contracts if you want this AL event to appear on Rota and staff overview.`,
        cancelLabel: "OK",
        hideOkButton: true,
      },
    });
  }

  saveData() {
    if (!this.isFDAEmptyOrNextAfterEnd()) {
      this.showNDAWarning();
    }

    if (this.isHoursGivenInInactiveContractAndAnyAS()) {
      this.showASWarning();
    }

    if (!this.isAnyLeftHoursLessThanGiven()) {
      this.sendData();
      return;
    }

    if (this.parentalLeaveSelected) {
      this.sendData();
      return;
    }
    this.subscription.add(
      this.dialogService
        .open(QuestionDialogComponent, {
          closeOnBackdropClick: false,
          context: {
            title: "Confirmation",
            message: `You will be giving more AL than the employee has accrued. Check policy before confirming.`,
            okLabel: "Confirm",
            cancelLabel: "Cancel",
          },
        })
        .onClose.subscribe((decision: boolean) => {
          if (decision) {
            this.sendData();
          }
        }),
    );
  }

  prepareData() {
    let events = [];
    const eventId = this.form.get("eventType").value;
    const eventTypeName = this.getEventTypeFullName();
    this.employeeContracts.forEach((leaving: any) => {
      events.push({
        startDate: this.form.get("leavingStart").value,
        endDate: this.form.get("leavingEnd").value,
        firstDayAvailable: this.form.get("firstDayAvailable").value,
        contractId: leaving.contractId,
        typeId: eventId,
        givenHrs: this.form.get(`leaving-${leaving.contractId}`).value,
        description: this.form.get("description").value,
        requiresAcceptance: this.form.get("requiresAcceptance").value,
        addedById: this.authUserService.getOriginalUser().id,
        acceptedById: this.authUserService.getOriginalUser().id,
      });
      events = events.filter((item) => item.givenHrs !== null);
    });
    return {
      employeeId: this.form.get("employeeId").value,
      description: this.form.get("description").value,
      isGivenMoreThanRecommended: this.isGivenMoreThanRecommended,
      eventTypeId: eventId,
      eventStartDate: this.form.get("leavingStart").value,
      eventEndDate: this.form.get("leavingEnd").value,
      firstDayAvailable: this.form.get("firstDayAvailable").value,
      eventType: eventTypeName,
      eventList: events,
    };
  }

  sendData() {
    this.canSave = false;
    const data = this.prepareData();
    let minutes = 0;
    const diffDays = data.eventEndDate.diff(data.eventStartDate, "days") + 1;
    data.eventList.forEach((e, i) => {
      const splittedTime = e.givenHrs.split(":");
      minutes +=
        parseInt(splittedTime[0], 10) * 60 + parseInt(splittedTime[1], 10);
    });
    const dialogRef = this.dialogService
      .open(ConfirmRequestHoursComponent, {
        hasBackdrop: true,
        context: {
          data: {
            hours: `${Math.floor(minutes / 60)}`,
            minutes: `${minutes % 60}`.padStart(2, "0"),
            eventType: data.eventType.toLowerCase(),
            days:
              diffDays >= 14
                ? `\nThis leave will be ${diffDays} days long.`
                : null,
            employeeStatus: this.employeeStatus,
          },
        },
      })
      .onClose.subscribe((result: "confirm" | null) => {
        if (result && result === "confirm") {
          const eventId = this.form.get("eventType").value;
          const eventTypeName = this.eventTypes.find(
            (x) => x.id === eventId,
          ).wordFullName;
          this.subscription.add(
            this.annualLeavingService
              .addNewLeaving(
                this.form.get("employeeUid").value,
                data,
                eventTypeName,
              )
              .subscribe(
                (response: any) => {
                  this.toastrService.success(response.message, "Success");
                  this.tableService.closeWindow(true, 0, this.tableIdentifier);
                },
                (err) => {
                  this.canSave = true;
                  this.toastrService.danger(getErrorMessage(err), "Error", {
                    duration: 60000,
                    destroyByClick: true,
                  });
                },
              ),
          );
        } else {
          this.canSave = true;
        }
      });
  }

  getSum(fieldName: any) {
    let minutesSum = 0;
    this.employeeContracts.forEach((element: any) => {
      minutesSum += getMinutes(element.leaveSettlements[fieldName]);
    });

    if (fieldName === "recommendedHrs") {
      this.recommendedHrsSum = getTime(minutesSum);
      this.recommendedHrsSumMinutes = minutesSum;
    } else if (fieldName === "maxHrs") {
      this.maxHrsCanGive = getTime(minutesSum);
      this.maxHrsCanGiveMinutes = minutesSum;
    }

    return getTime(minutesSum);
  }

  handleCalculateGivenHrs() {
    let minutesSum = 0;
    Object.keys(this.form.controls).forEach((key) => {
      if (key.includes("leaving-")) {
        minutesSum += getMinutes(this.form.get(key).value);
      }
    });

    this.givenHrsSum = getTime(minutesSum);
    this.givenHrsSumMinutes = minutesSum;
    this.checkIfHoursCorrect();
  }

  checkIfHoursCorrect() {
    if (this.parentalLeaveSelected) {
      this.isGivenMoreThanRecommended = false;
      this.isGivenMoreThanMax = false;
      return;
    }
    this.isGivenMoreThanRecommended =
      this.givenHrsSumMinutes > this.recommendedHrsSumMinutes;
    this.isGivenMoreThanMax =
      this.givenHrsSumMinutes > this.maxHrsCanGiveMinutes;
  }

  hideDetails() {
    this.showDetails = !this.showDetails;
    this.buttonDetailsText = this.showDetails
      ? "Hide full year AL"
      : "See full year AL";
  }

  isOnlyASOrNumberInserted(form: UntypedFormGroup) {
    const results = this.contractControlNames.map((name) => {
      const value = form.get(name).value;
      return (
        String(value).toLowerCase() === "as" ||
        XRegExp(
          "^([0-9]|[0-9][0-9]|[0-9][0-9]|[0-9][0-9][0-9]|[0-9][0-9][0-9][0-9]|2500)([:]{1})([0-5]{1})([0123456789]{1})$",
        ).test(value)
      );
    });
    return results.every((value) => value === true);
  }

  isOnly0OrAs(form: UntypedFormGroup) {
    if (this.isOnlyASOrNumberInserted(form)) {
      const results = this.contractControlNames.map((name) => {
        return false;
      });
      return results.every((value) => value === true);
    } else {
      return true;
    }
  }

  showASInfoIfCancelled(status: any) {
    this.showASInfo = status == "canceled";
  }

  closeWindow() {
    this.tableService.closeWindow(false);
    if (
      this.tableService &&
      this.tableService.getValue() &&
      this.tableService.getValue().closeButtonAdditional
    ) {
      this.tableService.getValue().closeButtonAdditional();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  calculateALHours(contract: any) {
    const SLEEPING_OPTIONS = 40;
    const sleepingInterval = contract.careHomeSleepingInterval;
    const sleepingIntervalHours = moment.duration(sleepingInterval).asHours();
    const hoursTable = [];
    hoursTable.push("0:00");
    for (let i = 1; i < SLEEPING_OPTIONS; i++) {
      hoursTable.push(this.getHoursAndMinutes(sleepingIntervalHours * i));
    }

    return hoursTable;
  }

  onRefreshData() {
    this.getCalendarData(true);
  }

  private getHoursAndMinutes(hours: number) {
    const MINUTES_IN_HOUR = 60;
    const minutes = hours * MINUTES_IN_HOUR;
    const hoursFromMinutes = Math.floor(hours);
    const minutesInHour = minutes % 60;
    const hoursString = this.getTimeStringFromNumber(hoursFromMinutes);
    const minutesString = this.getTimeStringFromNumber(minutesInHour);

    return `${hoursString}:${minutesString}`;
  }

  private getTimeStringFromNumber(time: number) {
    let minutesString = "";
    if (time === 0) {
      minutesString = "00";
    } else if (time < 10) {
      minutesString = `0${time}`;
    } else {
      minutesString = time.toString();
    }

    return minutesString;
  }

  private getCalendarData(openAfterLoad = false) {
    this.calendarMessageLeave = "";
    this.calendarMessageShifts = "";
    this.previousReqRange["from"] = this.dateRange.from;
    this.previousReqRange["to"] = this.dateRange.to;

    this.leaveDays =
      moment(this.form.get("leavingEnd").value).diff(
        moment(this.form.get("leavingStart").value),
        "days",
      ) + 1;

    this.dataLoaded = LoadingStatus.NOT_LOADED;
    let loadCount = 2;
    if (this.form.get("employeeId").value === null) {
      return;
    }
    if (this.employeeId) {
      this.subscription.add(
        this.overviewService
          .getDataForOtherEventsForEmployeeWithSorceEmployee(
            this.employeeUid,
            this.dateRange.from,
            this.dateRange.to,
            true,
          )
          .subscribe((response: any) => {
            if (!response.result.calendar) {
              this.calendarMessageLeave =
                "There are no other Annual Leave nor Sickness in this period.";
            } else {
              this.calendarData.months = this.transformCallendarData(
                response.result.list,
              );
            }

            loadCount--;
            if (loadCount == 0) {
              this.dataLoaded = LoadingStatus.LOADED;
            }
          }),
      );
      this.subscription.add(
        this.overviewService
          .getDataOfEmployeeSchedule(
            this.employeeUid,
            this.dateRange.from,
            this.dateRange.to,
          )
          .subscribe((responseSchedule: any) => {
            if (responseSchedule.result.list.length > 0) {
              this.schedule = responseSchedule.result.list;
              this.scheduleSummary = responseSchedule.result.summaryByRoleList;
              if (this.calendarData.months.length == 0) {
                this.calendarData.months = this.transformScheduleData(
                  responseSchedule.result.list,
                );
              }
            } else {
              this.calendarMessageShifts =
                "There are no shifts planned in this period.";
            }
            loadCount--;
            if (loadCount == 0) {
              this.dataLoaded = LoadingStatus.LOADED;
            }
            if (openAfterLoad) {
              setTimeout(() => {
                this.leaveItem.open();
              }, 200);
            }
          }),
      );
      this.subscription.add(
        this.employeeService
          .getUnaggregatedEventsWithoutCareHome(this.employeeUid, false)
          .subscribe((response: any) => {
            this.events = response.result.contractsLines;
            this.checkLast6Months();
          }),
      );
    }
  }

  private transformScheduleData(scheduleList: any[]) {
    const monthsData: { month: string; date: number }[] = [];
    const monthsArray = [];
    const monthsArrayTimestamps = [];
    scheduleList.forEach((schedule) => {
      if (!monthsArray.includes(moment(schedule.date).month())) {
        monthsArray.push(moment(schedule.date).month());
        monthsData.push({
          month: moment(schedule.date).format("MMMM"),
          date: moment(schedule.date).valueOf(),
        });
        monthsArrayTimestamps.push(moment(schedule.date).valueOf());
      }
    });
    return monthsData;
  }

  private transformCallendarData(callendarMonths: any[]) {
    const firstMonth = callendarMonths[0];
    let fmContracts = firstMonth.contracts;
    if (callendarMonths.length > 1) {
      fmContracts = fmContracts.concat(callendarMonths[1].contracts);
      fmContracts = fmContracts.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i,
      );
    }

    firstMonth.contracts = fmContracts;

    return [firstMonth];
  }

  checkHowManyDaysIncluded(contract: any, _numWorkDaysPerWeek: number): number {
    const eventOverallStart = moment(this.form.get("leavingStart").value);
    const eventOverallEnd = moment(this.form.get("leavingEnd").value);

    const contractMomentStart = moment(contract.contractStartDate);
    const contractMomentEnd = moment(contract.contractEndDate);

    const effectiveStart = moment.max(
      eventOverallStart.clone().startOf("day"),
      contractMomentStart.clone().startOf("day"),
    );
    const effectiveEnd = moment.min(
      eventOverallEnd.clone().startOf("day"),
      contractMomentEnd.clone().startOf("day"),
    );

    if (effectiveStart.isAfter(effectiveEnd)) {
      return 0;
    }

    const totalDays = effectiveEnd.diff(effectiveStart, "days") + 1;

    const fullWeeks = Math.floor(totalDays / 7);
    const remainder = totalDays % 7;

    return fullWeeks * 5 + Math.min(remainder, 5);
  }

  setHours(contract: any) {
    const workingDaysAWeek = 5;

    let daysIncluded = this.checkHowManyDaysIncluded(
      contract,
      workingDaysAWeek,
    );

    if (daysIncluded == 0) {
      return "0:00";
    }

    const contractMinutesPerWeek = contract.contractMinutesPerWeek as number;
    //int division
    const weeks = (daysIncluded / workingDaysAWeek) | 0;
    const remainingDays = daysIncluded % workingDaysAWeek;
    const remainingPartOfWeek = Math.min(remainingDays / workingDaysAWeek, 1);

    const weeksTotal = weeks + remainingPartOfWeek;

    const totalTime = contractMinutesPerWeek * weeksTotal;
    const hours = Math.floor(totalTime / 60);
    const minutes = totalTime % 60;

    return `${hours}:${this.roundToQuarterHour(minutes)}`;
  }

  explainAnnual() {
    this.dialogService.open(ExplainAnnualLeaveComponent, {
      hasBackdrop: true,
      context: {
        data: {
          employeeName: this.employeeFullName,
          employeeId: this.employeeId,
          explanation: this.explanationAnnualLeave,
          alText: this.alText,
        },
      },
    });
  }

  get parentalLeaveSelected(): boolean {
    return (
      this.parentalLeaveId === this.form.controls.eventType.value ||
      this.materialityLeaveId === this.form.controls.eventType.value
    );
  }

  get hideColumns(): boolean {
    // Production: hide Given Hrs for PL / ML / RO (keep existing behaviour)
    return (
      this.parentalLeaveId === this.form.controls.eventType.value ||
      this.materialityLeaveId === this.form.controls.eventType.value ||
      this.requestOffId === this.form.controls.eventType.value
    );
  }

  public roundToQuarterHour(minutes: number): string {
    const roundedMinutes = Math.round(minutes / 15) * 15;
    return roundedMinutes.toString().padStart(2, "0");
  }

  private checkLast6Months(): void {
    const consideredEventShortNames = ["ML", "PL"];

    const eventTypeShortName = this.getEventTypeShortName();

    if (!consideredEventShortNames.includes(eventTypeShortName)) return;

    const startDate = this.form.get("leavingStart").value;

    const windowEnd = startDate.clone().endOf("day");
    const windowStart = startDate.clone().subtract(6, "months").startOf("day");

    const consideredEvents = this.events.filter((event) => {
      return consideredEventShortNames.includes(event.eventTypeShort);
    });

    let eventTypeInRange = "";

    const hadLeaveInLast6Months = consideredEvents.some((event) => {
      const eventEndDate = moment(
        event.eventEndDate,
        "YYYY/MM/DD",
        true,
      ).startOf("day");

      const inRange = eventEndDate.isBetween(
        windowStart,
        windowEnd,
        "day",
        "[]",
      );

      if (inRange) eventTypeInRange = event.eventTypeFull;

      return inRange;
    });

    if (hadLeaveInLast6Months) {
      this.dialogService.open(PeriodCheckDialogComponent, {
        hasBackdrop: true,
        closeOnBackdropClick: false,
        context: {
          data: {
            eventTypeName: eventTypeInRange.toLowerCase(),
          },
        },
      });
    }
  }

  private getEventTypeShortName() {
    const id = this.form.get("eventType").value;
    const shortName = this.eventTypes.find((x) => x.id === id).wordShortName;
    return shortName;
  }

  private getEventTypeFullName() {
    const id = this.form.get("eventType").value;
    const fullName = this.eventTypes.find((x) => x.id === id).wordFullName;
    return fullName;
  }
}

export interface IPreviousReq {
  from: moment.Moment | undefined;
  to: moment.Moment | undefined;
}
